import * as types from '@/redux/actionTypes';

const initState = {
  loading: false,
  idList: [],
  entities: {},
  tempResume: { loading: false },
  uploadResult: {},
  applicationNoMore: true,
  minAppliedAt: null,
  minApplicationId: null,
  filter: {},
  excelApplicationStats: [],
  excelDupApplications: [],
  captchaId: '09c6c054f9fe48f4b3f78d989b0e4e36',
  enterDup: false,
  successCount: 0,
  failedCount: 0,
};

function applications(state = initState, { type, payload }) {
  switch (type) {
    case types.LOAD_APPLICATION_LIST: {
      return {
        ...state,
        loading: payload,
      };
    }

    case types.CLEAR_APPLICATION_INFO: {
      return {
        ...state,
        idList: [],
        entities: {},
        tempResume: { loading: false },
        applicationNoMore: true,
        minAppliedAt: null,
        minApplicationId: null,
        filter: {},
        excelApplicationStats: [],
      };
    }

    case types.UPDATE_APPLICATION: {
      const application = payload.application;
      const entities = { ...state.entities };
      if (application) {
        entities[application.id] = entities[application.id]
          ? { ...entities[application.id], ...application }
          : application;
      }
      return {
        ...state,
        entities,
      };
    }

    case types.UPDATE_EXCEL_APPLICATION_LIST: {
      return {
        ...state,
        excelApplicationStats: payload,
      };
    }

    case types.REPLACE_EXCEL_DUP_APPLICATIONS: {
      const excelDupApplications = payload.applications || [];
      return {
        ...state,
        excelDupApplications,
      };
    }

    case types.CLEAR_EXCEL_DUP_APPLICATIONS: {
      return {
        ...state,
        excelDupApplications: [],
      };
    }

    case types.UPLOAD_RESUME: {
      return {
        ...state,
        tempResume: payload,
      };
    }

    case types.UPLOAD_CANDIDATE_RESULT: {
      return {
        ...state,
        uploadResult: payload,
      };
    }
    case types.ENTERING_DUPLICATE: {
      const { enterDup, successCount, failedCount } = payload;
      return {
        ...state,
        enterDup,
        successCount,
        failedCount,
      };
    }
    default:
      return state;
  }
}

export default applications;
